import { render, staticRenderFns } from "./VueTourHeader.vue?vue&type=template&id=6e274d80&scoped=true"
import script from "./VueTourHeader.vue?vue&type=script&lang=js"
export * from "./VueTourHeader.vue?vue&type=script&lang=js"
import style0 from "./VueTourHeader.vue?vue&type=style&index=0&id=6e274d80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e274d80",
  null
  
)

export default component.exports